import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import type SortableHandle from 'ember-sortable/components/sortable-handle';
import sortableHandle from 'ember-sortable/modifiers/sortable-handle';
import UiCard from 'garaje/components/ui/card';
import UiWellItem from 'garaje/components/ui/well/item';

interface SignInFieldsWrapperSignature {
  Args: {
    /**
     * CSS classes to be applied to the `<UiCard>` element.
     * Only ised if `@isCarded` is false.
     */
    cardClass?: string;
    dragHandleFor?: string;
    handleItem?: { handle: typeof SortableHandle };
    isCarded: boolean;
    isDeletable: boolean;
    isDraggable: boolean;
    onDelete: () => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  {{#if @isCarded}}
    <div class="relative flex items-center" ...attributes>
      <div class="flex-auto flex flex-col space-y-4">
        {{yield}}
      </div>

      {{#if @isDeletable}}
        <button
          class="absolute btn btn--smaller btn--square btn--hoverFill"
          style="right:-6.45rem"
          type="button"
          tabindex="-1"
          {{on "click" @onDelete}}
          data-test-delete
        >
          <span class="icon-trash"></span>
        </button>
      {{/if}}
    </div>
  {{else}}
    <UiWellItem ...attributes>
      <UiCard class="space-y-4 {{@cardClass}}">
        {{yield}}
      </UiCard>

      {{#if @handleItem}}
        {{#let @handleItem as |item|}}
          <item.handle
            class={{if @isDraggable "icon-reSort" "opacity-0 pointer-events-none"}}
            aria-hidden={{if @isDraggable false true}}
            data-custom-handle
            data-test-handle-for={{@dragHandleFor}}
          />
        {{/let}}
      {{else if @isDraggable}}
        <div
          {{sortableHandle}}
          class={{if @isDraggable "icon-reSort" "opacity-0 pointer-events-none"}}
          aria-hidden={{if @isDraggable false true}}
          data-custom-handle
          data-test-handle-for={{@dragHandleFor}}
        />
      {{/if}}

      {{#if @isDeletable}}
        <button
          class="btn btn--smaller btn--square btn--hoverFill {{unless @isDraggable '!ml-12'}}"
          type="button"
          tabindex="-1"
          {{on "click" @onDelete}}
          data-test-delete
        >
          <span class="icon-trash"></span>
        </button>
      {{/if}}
    </UiWellItem>
  {{/if}}
</template> satisfies TOC<SignInFieldsWrapperSignature>;
